import { useQuery } from '@tanstack/react-query';

import { AmendmentVersionGroup } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useGroupAmendments = (lrn: string) =>
  useQuery({
    queryKey: ['group-amendments', lrn],
    queryFn: async (): Promise<AmendmentVersionGroup[]> => {
      try {
        const result = await apiClient.declarations.getAmendmentsByLrn.query({ params: { lrn } });
        if (result.status !== 200) throw result.body;

        return result.body.data as AmendmentVersionGroup[];
      } catch (error) {
        showErrorToast(error, 'Failed to fetch amendments');
      }
    },
    enabled: !!lrn,
  });
